
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/certification/about",
      function () {
        return require("private-next-pages/certification/about.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/certification/about"])
      });
    }
  